module.exports = __webpack_public_path__ + "static/media/booking-header-bg@0x.e9c8f259.png";